define('modules/lp_integration/views/validation_popup',['require','exports','module'],function(require, exports, module){
  "use strict";
  module.exports = {
    showValidationErrors: function(){
      var errors = this.model.validationError;
      _.each(errors, function(err){
        var $field = this.$("#" + err.attribute),
            $message = this.$("#" + err.attribute + "-message"),
            validationMessageKey = this.i18n.validation[err.attribute];
        $field.parent().addClass("has-error");
        $message.html($.i18n.t(validationMessageKey));
      }, this);

    },
    clearValidationErrors: function(){
      this.$(".has-error").removeClass("has-error");
      this.$(".js-error-message").html("");
    },
    onRender: function(){
      this.$el.i18n();
      if(this.model){
        if(this.model.isValid() || this.model.isEmpty()){
          this.clearValidationErrors();
        }
        else {
          this.showValidationErrors();
        }
      }
    }
  };
});

